(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vybe-home-professional"] && !Shopify.designMode) return;
  try {
    
const setupVybeCarousel = (carousel) => {
  if (carousel.dataset.ready === 'true') return
  const slides = [...carousel.querySelectorAll('[data-vp-slide]')]
  const previous = carousel.querySelector('[data-vp-prev]')
  const next = carousel.querySelector('[data-vp-next]')
  const dots = carousel.querySelector('[data-vp-dots]')
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
  let active = 0
  let timer
  let pointerStart = 0
  const positions = ['is-active', 'is-prev', 'is-next', 'is-far-prev', 'is-far-next']
  const render = () => {
    slides.forEach((slide, index) => {
      positions.forEach((position) => slide.classList.remove(position))
      let distance = (index - active + slides.length) % slides.length
      if (distance > slides.length / 2) distance -= slides.length
      if (distance === 0) slide.classList.add('is-active')
      if (distance === -1) slide.classList.add('is-prev')
      if (distance === 1) slide.classList.add('is-next')
      if (distance === -2) slide.classList.add('is-far-prev')
      if (distance === 2) slide.classList.add('is-far-next')
      slide.tabIndex = distance === 0 ? 0 : -1
      slide.setAttribute('aria-hidden', distance === 0 ? 'false' : 'true')
    })
    ;[...dots.children].forEach((dot, index) => {
      dot.classList.toggle('is-active', index === active)
      dot.setAttribute('aria-current', index === active ? 'true' : 'false')
    })
  }
  const move = (direction) => {
    active = (active + direction + slides.length) % slides.length
    render()
  }
  const stop = () => window.clearInterval(timer)
  const start = () => {
    stop()
    if (!reducedMotion.matches) timer = window.setInterval(() => move(1), 3600)
  }
  slides.forEach((slide, index) => {
    const dot = document.createElement('button')
    dot.type = 'button'
    dot.setAttribute('aria-label', `Mostra prodotto ${index + 1}`)
    dot.addEventListener('click', () => {
      active = index
      render()
      start()
    })
    dots.append(dot)
  })
  previous.addEventListener('click', () => {
    move(-1)
    start()
  })
  next.addEventListener('click', () => {
    move(1)
    start()
  })
  carousel.addEventListener('mouseenter', stop)
  carousel.addEventListener('mouseleave', start)
  carousel.addEventListener('focusin', stop)
  carousel.addEventListener('focusout', start)
  carousel.addEventListener('pointerdown', (event) => {
    pointerStart = event.clientX
  })
  carousel.addEventListener('pointerup', (event) => {
    const distance = event.clientX - pointerStart
    if (Math.abs(distance) > 42) move(distance > 0 ? -1 : 1)
    start()
  })
  reducedMotion.addEventListener('change', start)
  carousel.dataset.ready = 'true'
  render()
  start()
}
document.querySelectorAll('[data-vp-carousel]').forEach(setupVybeCarousel)
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-vp-carousel]').forEach(setupVybeCarousel)
})

  } catch(e) { console.error(e); }
})();
})();
